import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import getOfficeSlug from '@helpers/getOfficeSlug';

import st from './CloseInfo.module.css';

type CloseInfoProps = {
  isDetailed?: boolean;
  office?: OfficeTypeProps;
};

const CloseInfo: FC<CloseInfoProps> = ({ isDetailed = false, office }) => {
  const { replacementOffice } = office;
  const area = null;
  // const nearOffices = null;

  return (
    <div className={st.container}>
      <div className={isDetailed ? st.titleDetailed : st.title}>
        Закрыт на капитальный ремонт
      </div>

      {replacementOffice && (
        <div className={isDetailed ? st.containerDetailed : ''}>
          <div className={st.description}>
            {`Для обслуживания жителей района ${area ? `${area} ` : ''}открыт `}
            <Link
              data-testid="addOffice"
              className={st.link}
              to={`/services/centry-gosudarstvennyh-uslug/${getOfficeSlug(
                replacementOffice
              )}`}
            >
              <span>дополнительный офис</span>
            </Link>
            {' по адресу: '}
            {replacementOffice.address?.value}
          </div>
          {/* {isDetailed && (
            <>
              <div className={st.footerTitle}>ЦГУ поблизости</div>
              {nearOffices.map((nearestOffice) => (
                <Link
                  key={nearestOffice.id}
                  className={st.footerLink}
                  to={`/${getOfficeSlug(nearestOffice)}`}
                >
                  {nearestOffice.name}
                </Link>
              ))}
            </>
          )} */}
        </div>
      )}
    </div>
  );
};

export default CloseInfo;
